var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktokGradient = function SvgTiktokGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tiktok-gradient_svg__a)",
    d: "M19.089 38h-.084C8.555 38 .053 29.495.053 19.042v-.084C.053 8.505 8.555 0 19.005 0h.084c10.45 0 18.953 8.505 18.953 18.958v.084C38.042 29.495 29.539 38 19.089 38m-.084-36.714C9.264 1.286 1.34 9.213 1.34 18.958v.084c0 9.744 7.925 17.672 17.666 17.672h.084c9.742 0 17.667-7.927 17.667-17.672v-.084c0-9.745-7.925-17.672-17.667-17.672z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tiktok-gradient_svg__b)",
    d: "M26.684 15.022v2.751a7.23 7.23 0 0 1-3.81-1.542v5.56l-.01-.017q.01.166.01.336a5.015 5.015 0 0 1-5.008 5.01 5.015 5.015 0 0 1-5.008-5.01 5.016 5.016 0 0 1 5.803-4.947v2.712a2.375 2.375 0 0 0-3.167 2.236 2.375 2.375 0 0 0 2.372 2.372 2.375 2.375 0 0 0 2.368-2.52V11.157h2.749q.014.35.03.7c.017.459.18.899.465 1.26.334.423.827.915 1.52 1.308a5.2 5.2 0 0 0 1.686.6z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tiktok-gradient_svg__a",
    x1: 9.55,
    x2: 34.886,
    y1: 0,
    y2: 37.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6937F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#FFE5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tiktok-gradient_svg__b",
    x1: 16.315,
    x2: 27.459,
    y1: 11.157,
    y2: 25.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6937F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#FFE5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })))));
};
export default SvgTiktokGradient;